

// Import ----------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";
import { Context } from "@nuxt/types";

// Project
import MainPage from "~/layouts/Main.vue";
import ContentGateway from "~/libs/ContentGateway";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        MainPage
    },

    // Nuxt Hooks --------------------------------------------------------------

    async asyncData (context: Context) {
        const { params, error } = context;

        try {
            const node = await ContentGateway.make(context).getNode(params.pathMatch);
            return { node };
        } catch (err) {
            error({
                statusCode: 404,
                message: "Page could not be found"
            });
        }
    }

    // -------------------------------------------------------------------------
});

